import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { A11yModule } from '@angular/cdk/a11y';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { Globle } from 'src/assets/globle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';


import { EFawateercomRoutingModule } from './e-fawateercom-routing.module';
import { CategoryListComponent } from './category/category-list/category-list.component';
import { CategoryFormComponent } from './category/category-form/category-form.component';
import { EfcategoryService } from './category/efcategory.service';
import { BillerslistComponent } from './billers-list/billerslist/billerslist.component';
import { BillersformComponent } from './billers-list/billersform/billersform.component';
import { MatspinnerComponent } from './matspinner/matspinner.component';
import { ServicetypelistComponent } from './serviceType/servicetypelist/servicetypelist.component';
import { ServicetypeformComponent } from './serviceType/servicetypeform/servicetypeform.component';
import { FeescategoryComponent } from './feescategory/feescategory.component';
import { GoodcardintcInterceptor } from '../goodcardintc.interceptor';
import { FeescategoryserviceService } from './feescategory/feescategoryservice.service';


@NgModule({
  declarations: [
    CategoryListComponent, CategoryFormComponent, BillerslistComponent, BillersformComponent, MatspinnerComponent, ServicetypelistComponent, ServicetypeformComponent, FeescategoryComponent],
  imports: [
    CommonModule,
    EFawateercomRoutingModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatDialogModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatRippleModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    A11yModule,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [FeescategoryserviceService,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
    Globle,
    EfcategoryService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GoodcardintcInterceptor,
      multi: true
    },
  ]
})
export class EFawateercomModule { }
